/**
 * Phone Number Validation Utilities
 * 
 * NOTE: OTP sending and verification are handled by Cloud Functions
 * in functions/src/auth.ts (sendOTP and verifyOTP endpoints).
 * These functions should NEVER directly access the otpSessions collection
 * as it's backend-only for security.
 */

/**
 * Format phone number for display
 * @param phoneNumber - Raw phone number
 * @returns Formatted phone number (e.g., +91 98765 43210)
 */
export function formatPhoneNumber(phoneNumber: string): string {
  const cleanPhone = phoneNumber.replace(/[\s\-()]/g, '');
  
  if (cleanPhone.startsWith('+91') && cleanPhone.length === 13) {
    return `${cleanPhone.slice(0, 3)} ${cleanPhone.slice(3, 8)} ${cleanPhone.slice(8)}`;
  }
  
  return phoneNumber;
}

/**
 * Validate Indian phone number
 * @param phoneNumber - Phone number to validate
 * @returns true if valid
 */
export function validateIndianPhoneNumber(phoneNumber: string): boolean {
  const cleanPhone = phoneNumber.replace(/[\s\-()]/g, '');
  
  // Check for 10 digits (without country code)
  if (/^[6-9]\d{9}$/.test(cleanPhone)) {
    return true;
  }
  
  // Check for +91 followed by 10 digits
  if (/^\+91[6-9]\d{9}$/.test(cleanPhone)) {
    return true;
  }
  
  return false;
}
